module.exports = __webpack_public_path__ + "static/media/student_success.56e911b4.jpg";